import {config} from '../../utils.js';
import {sendAppEvent} from '../../tracking/app-events.js';

const PURCHASE_EVENT = 'purchase2';

export const transactionPaidAppEventListener = () =>
  window.addEventListener(
    'load',
    () =>
      'transactionPaid' in config &&
      sendAppEvent(
        PURCHASE_EVENT,
        config.transactionPaid
      )
  );
